module.exports = __webpack_public_path__ + "fonts/HKNova-ExtraBold.d2bc18b4.woff";